import { render, staticRenderFns } from "./updateuserdetails.vue?vue&type=template&id=0a131023"
import script from "./updateuserdetails.vue?vue&type=script&lang=js"
export * from "./updateuserdetails.vue?vue&type=script&lang=js"
import style0 from "./updateuserdetails.vue?vue&type=style&index=0&id=0a131023&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports